import React, { memo } from 'react'
import { Avatar, Box, Stack, TableCell, Typography, useTheme } from '@mui/material'
import { LOGOS_BASE_URL } from '../../assets/constants'
import { getColorForSymbol } from '../../util/general'
import { Security } from '../../proto/generated/security'
import CompanyEvents from '../CompanyEvents/companyEvents'
import { NonInteractiveTooltip } from '../custom'
import { exchangeToJSON } from '../../proto/generated/common'
import { indexComponentBodyCellSx } from './indexComponentTableStyles'

export type IndexComponentSymbolCellProps = {
    security: Security
    onPopoverOpenChange?: (open: boolean) => void
}

const IndexComponentSymbolCell = ({ security, onPopoverOpenChange }: IndexComponentSymbolCellProps) => {
    const theme = useTheme()
    const displayName = security.displayName
    const logoUrl = security.logoUrl
    const title = (
        <Typography variant="body2">
            {displayName} | {exchangeToJSON(security.exchange)}
        </Typography>
    )

    return (
        <TableCell sx={{ ...indexComponentBodyCellSx, minWidth: 130, width: '36%' }}>
            <NonInteractiveTooltip placement="left" arrow title={title}>
                <Stack direction="row" spacing={0.5} alignItems="center">
                    {logoUrl ? (
                        <Avatar alt={displayName} src={`${LOGOS_BASE_URL}${logoUrl}.svg`} sx={{ width: 18, height: 18, flexShrink: 0 }} />
                    ) : (
                        <Avatar
                            alt="Security Logo"
                            sx={{
                                width: 18,
                                height: 18,
                                fontSize: 10,
                                color: 'white',
                                flexShrink: 0,
                                bgcolor: getColorForSymbol(security.symbol || security.code, theme.palette.background.default),
                            }}
                        >
                            {(security.symbol || security.code)
                                .split(' ')
                                .map((word) => word[0]?.toUpperCase())
                                .slice(0, 2)
                                .join('')}
                        </Avatar>
                    )}
                    <Typography
                        noWrap
                        variant="body2"
                        sx={{
                            fontSize: '0.8125rem',
                            lineHeight: 1.2,
                            maxWidth: 'calc(100% - 24px)',
                            flexGrow: 1,
                            textOverflow: 'ellipsis',
                        }}
                    >
                        {security.symbol}
                    </Typography>
                    <Box sx={{ ml: 'auto', display: 'flex', flexShrink: 0 }}>
                        <CompanyEvents companyCode={security.companyCode || ''} onPopoverOpenChange={onPopoverOpenChange} />
                    </Box>
                </Stack>
            </NonInteractiveTooltip>
        </TableCell>
    )
}

export default memo(IndexComponentSymbolCell)
